import { render, staticRenderFns } from "./communicationDetail.vue?vue&type=template&id=253c44c4&scoped=true"
import script from "./communicationDetail.vue?vue&type=script&lang=js"
export * from "./communicationDetail.vue?vue&type=script&lang=js"
import style0 from "./communicationDetail.vue?vue&type=style&index=0&id=253c44c4&prod&lang=scss"
import style1 from "./communicationDetail.vue?vue&type=style&index=1&id=253c44c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253c44c4",
  null
  
)

export default component.exports